import { Icon, IIconName } from '@features/siteStatusV2/components/icon';
import { EligibilityStatus } from '@features/siteStatusV2/constants';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import MapBadgeInformations from './constants/BadgeInformations.map';
import { TranslationNamespaces } from '../../../../locales/constants/translationNamespaces.enum';

interface EligibilityBadgeProps {
  status: EligibilityStatus;
  icon?: IIconName;
  setIsModalShown: React.Dispatch<React.SetStateAction<boolean>>;
}

const EligibilityBadge: React.FC<EligibilityBadgeProps> = ({ status, icon, setIsModalShown }) => {
  const { t } = useTranslation(TranslationNamespaces.SITE_STATUS);

  const handleShowModal = () => {
    if (status === EligibilityStatus.FROZEN_ADDRESS) {
      setIsModalShown(true);
    }
  };

  return (
    <EligibilityBadgeContainer status={status} onClick={handleShowModal}>
      <TextContainer status={status}>{t(MapBadgeInformations[status]?.badgeText)}</TextContainer>
      {icon && (
        <IconContainer>
          <CustomIcon iconName={icon.iconName} status={status} />
        </IconContainer>
      )}
    </EligibilityBadgeContainer>
  );
};

const CustomIcon = styled(Icon)<{ status: EligibilityStatus }>`
  width: 0.725rem;
  color: ${({ status }) => MapBadgeInformations[status]?.textColor};
  fill: ${({ status }) => MapBadgeInformations[status]?.textColor};
`;

const IconContainer = styled.div`
  width: 1rem;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 0.125rem;
`;

const TextContainer = styled.div<{ status: EligibilityStatus }>`
  font-size: 0.725rem;
  line-height: 0.75rem;
  font-weight: 500;
  text-align: center;
  color: ${({ status }) => MapBadgeInformations[status]?.textColor};
`;

const EligibilityBadgeContainer = styled.div<{ status: EligibilityStatus }>`
  width: fit-content;
  height: 1rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  border-width: 0px;
  border-radius: 0.25rem;
  background-color: ${({ status }) => MapBadgeInformations[status]?.backgroundColor};
  border-style: solid;
  margin-right: 0.625rem;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  cursor: ${({ status }) => (status === EligibilityStatus.FROZEN_ADDRESS ? 'pointer' : '')};
`;

export default EligibilityBadge;
